import { useState, useEffect } from "react";
import { db } from "./firebase";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import './GlossaryPage.css';

export default function GlossaryPage() {
  const [word, setWord] = useState("");
  const [meaning, setMeaning] = useState("");
  const [entries, setEntries] = useState([]);
  const [flippedIndex, setFlippedIndex] = useState(null);

  useEffect(() => {
    const fetchGlossary = async () => {
      const snapshot = await getDocs(collection(db, "glossary"));
      const items = snapshot.docs.map(doc => doc.data());
      setEntries(items);
    };
    fetchGlossary();
  }, []);

  const handleSubmit = async () => {
    if (!word || !meaning) return;
    await addDoc(collection(db, "glossary"), {
      word,
      meaning,
      createdAt: new Date()
    });
    setWord("");
    setMeaning("");
    const snapshot = await getDocs(collection(db, "glossary"));
    const items = snapshot.docs.map(doc => doc.data());
    setEntries(items);
  };

  return (
    <div className="container">
    <div style={{ padding: '2rem', backgroundColor: '#000', color: '#fff', minHeight: '100vh' }}>
     <Link to="/">Home</Link> | <Link to="/explore"> Archive </Link> | <Link to="/glossary"> Whispered Footnotes </Link> | <Link to="/about">About</Link>

      <h2 style={{ fontSize: '2rem'}}>Whispered footnotes</h2>
      <div className="section">
        <p> A quiet archive of what doesn't translate. These are the words we inherit, invent, and carry—half-remembered, often mispronounced, always meaningful. In each entry, something lingers: a gesture, a story, a refusal to be erased. Words that are close to people, cultures, and the meanings they associate. Explore the footnoes or leave your own! </p>
      </div>
      <div style={{ marginTop: '1rem' }}>
        <input
          type="text"
          placeholder="An untranslatable word"
          value={word}
          onChange={(e) => setWord(e.target.value)}
          style={{ marginRight: '0.5rem', padding: '0.5rem' }}
        />
        <input
          type="text"
          placeholder="The meaning or feeling it represents for you"
          value={meaning}
          onChange={(e) => setMeaning(e.target.value)}
          style={{ marginRight: '0.5rem', padding: '0.5rem', width: '300px' }}
        />
        <button onClick={handleSubmit} style={{ padding: '0.5rem 1rem' }}>
          Submit
        </button>
      </div>

      <div className="glossary-grid">
        {entries.map((entry, index) => (
          <div
            key={index}
            className={`glossary-card ${flippedIndex === index ? 'flipped' : ''}`}
            onClick={() => setFlippedIndex(flippedIndex === index ? null : index)}
          >
            <div className="glossary-card-inner">
              <div className="glossary-card-front">
                <strong>{entry.word}</strong>
              </div>
              <div className="glossary-card-back">
                <p>{entry.meaning}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      
    </div>
    </div>
  );
}
